import React, { memo } from "react"
import { Redirect } from "react-router-dom"
import { Hidden } from "@material-ui/core"
import routes from "app/routes"
import AppRoutes from "./AppRoutes"

const routesMobile = routes.filter(({ hiddenOnMobile }) => !hiddenOnMobile)

function Router() {
  return (
    <>
      <Hidden xsDown={true}>
        <AppRoutes routes={routes} />
      </Hidden>
      <Hidden smUp={true}>
        <AppRoutes routes={routesMobile}>
          <Redirect to="/personal-planning" />
        </AppRoutes>
      </Hidden>
    </>
  )
}
export default memo(Router)
